import { render, staticRenderFns } from "./Header-Info.vue?vue&type=template&id=78965889&scoped=true"
import script from "./Header-Info.vue?vue&type=script&lang=js"
export * from "./Header-Info.vue?vue&type=script&lang=js"
import style0 from "./Header-Info.vue?vue&type=style&index=0&id=78965889&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78965889",
  null
  
)

export default component.exports